import { render, staticRenderFns } from "./type-card.vue?vue&type=template&id=7227af7a"
import script from "./type-card.vue?vue&type=script&lang=js"
export * from "./type-card.vue?vue&type=script&lang=js"
import style0 from "./type-card.vue?vue&type=style&index=0&id=7227af7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports